import instance from '../../../util/axios';

export const loginByAuth = async (values) => {
  const URL = 'auth/login';
  console.log('🚀 ~ loginByAuth ~ URL:', URL);
  const response = await instance.post(URL, values);
  console.log('res...', response);
  const res = response;
  return res;
};
